import React, { useState, useRef, useEffect, useContext } from "react";
import { useDraggable } from "react-use-draggable-scroll";
import { Document, Page, pdfjs } from "react-pdf";
import { useTranslation } from "react-i18next";

import { LayoutContext } from "@layouts/MasterLayout.react";
import "@styles/readers.scss";

import { Div, Icon } from "@components/Generics.react";
import DeckToolbar from "@components/DeckToolbar.react";
import { clientAssetsPath } from "@api/apiV6";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export default function DocumentReader(props) {
    const { deck, closeDeck, recordAttempt } = props;
    const { fullScreen, setFullScreen } = useContext(LayoutContext);
    const { t } = useTranslation("common");

    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(0);
    const [maxRead, setMaxRead] = useState(1);
    const [scale, setScale] = useState(1);
    const docref = useRef();
    const { events } = useDraggable(docref, {
        applyRubberBandEffect: true, // activate rubber band effect
    });

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
        // if (currentState?.viewedPercentage) {
        //     setPageNumber(
        //         Math.floor((currentState.viewedPercentage * numPages) / 100)
        //     );
        // }
    }

    useEffect(() => {
        if (maxRead <= pageNumber + 1) setMaxRead(pageNumber);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pageNumber]);

    //---------------------------------------------------------------------------
    // Completion Tracking
    //---------------------------------------------------------------------------
    useEffect(() => {
        if (numPages > 0) {
            recordAttempt({
                viewedPercentage:
                    parseInt(((maxRead + 1) * 100) / numPages, 0) || 0,
                completion: numPages && maxRead >= numPages - 1,
                pointsDelta: 0,
                score: null,
                showEnding: maxRead >= numPages,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [numPages, maxRead]);

    const targetWidth = docref.current?.getBoundingClientRect().width - 15;
    const targetHeight = docref.current?.getBoundingClientRect().height - 15;

    // ========================= Render Function =================================

    return (
        <Div
            fullht
            fluid
            centered
            center-align
            compact
            noOverflow
            relative
            half
            gapTop
        >
            <div {...events} ref={docref} className="doc-viewport">
                <Document
                    // file={`https://s2.q4cdn.com/175719177/files/doc_presentations/Placeholder-PDF.pdf`}
                    file={`${clientAssetsPath}/uploads/docdecks/${deck._id}.pdf`}
                    onLoadSuccess={onDocumentLoadSuccess}
                    onContextMenu={(e) => e.preventDefault()} // Used to prevent download of the PDF
                >
                    <Page
                        pageNumber={pageNumber + 1}
                        width={targetWidth}
                        height={targetHeight}
                        scale={scale}
                    />
                </Document>
            </div>
            <DeckToolbar
                {...{
                    scale,
                    setScale,
                    pageNumber,
                    setPageNumber,
                    numPages,
                    fullScreen,
                    setFullScreen,
                }}
            />
            <Div className="close-icon" onClick={closeDeck}>
                {t("deck.close")} <Icon name="close" inline fitted />
            </Div>
        </Div>
    );
}
